import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));

const jwtLoginElement = (
  <AuthClassicLayout>
    <JwtLoginPage />
  </AuthClassicLayout>
);

const authJwt = {
  path: 'jwt',
  element: (
    <GuestGuard>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      path: 'login',
      element: jwtLoginElement,
    },
  ],
};

export const authRoutes = [
  {
    path: 'tpsg-login',
    element: (
      <GuestGuard>
        <Suspense fallback={<SplashScreen />}>{jwtLoginElement}</Suspense>
      </GuestGuard>
    ),
  },
  {
    path: 'auth',
    children: [authJwt],
  },
];
